import { mapActions, mapGetters, mapState } from 'vuex'

import CONSTANTS from '@/constants'

const {
  PLANS,
  BLACK_FRIDAY_PRODUCT_BUNDLES,
  LEAP_YEAR_PROMO_PRODUCT_BUNDLES,
  TCS_PROMO_PRODUCT_BUNDLES,
  VOUCHERS,
} = CONSTANTS
const {
  INE_BLACK_FRIDAY_BUNDLE_ONE,
  INE_BLACK_FRIDAY_BUNDLE_TWO,
  INE_BLACK_FRIDAY_BUNDLE_THREE,
  ERRORS: BF_ERRORS,
} = BLACK_FRIDAY_PRODUCT_BUNDLES
const { INE_LEAP_YEAR_BUNDLE, ERRORS: LY_ERRORS } = LEAP_YEAR_PROMO_PRODUCT_BUNDLES
const { INE_TCS_BUNDLE, ERRORS: TCS_ERRORS } = TCS_PROMO_PRODUCT_BUNDLES

export const promoProductBundleUtils = {
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
      availablePlans: state => state.products.availablePlans,
      availableCertifications: state => state.products.availableCertifications,
    }),
    ...mapGetters({
      isBlackFridayActive: 'app/isBlackFridayActive',
      isLeapYearPromoActive: 'app/isLeapYearPromoActive',
      isTCSPromoEnabled: 'featureFlags/isTCSPromoEnabled',
      isPromotionActive: 'app/isPromotionActive',
      isCyberMondayActive: 'app/isCyberMondayActive',
    }),
    promoBundlesOnCart() {
      return this.shoppingCart.find(
        item =>
          (item.slug && Object.values(BLACK_FRIDAY_PRODUCT_BUNDLES).includes(item.slug)) ||
          (item.slug && Object.values(LEAP_YEAR_PROMO_PRODUCT_BUNDLES).includes(item.slug)) ||
          (item.slug && Object.values(TCS_PROMO_PRODUCT_BUNDLES).includes(item.slug)) ||
          (item.merchant_id && item.merchant_id === PLANS.ANNUAL)
      )
    },
    promoBundleOneOnCart() {
      return (
        this.shoppingCart.find(item => item.slug && item.slug === INE_BLACK_FRIDAY_BUNDLE_ONE) ||
        false
      )
    },
    promoBundleTwoOnCart() {
      return (
        this.shoppingCart.find(item => item.slug && INE_BLACK_FRIDAY_BUNDLE_TWO === item.slug) ||
        false
      )
    },
    promoFundamentalsBundleOnCart() {
      return (
        this.shoppingCart.find(
          item =>
            (item.slug && item.slug === INE_BLACK_FRIDAY_BUNDLE_THREE) ||
            (item.merchant_id && item.merchant_id === PLANS.ANNUAL)
        ) || false
      )
    },
    fundamentalsAnnual() {
      return this.availablePlans.find(item => item.merchant_id && item.merchant_id === PLANS.ANNUAL)
    },
    elegibleAvailableCertifications() {
      return this.availableCertifications.filter(cert => cert.merchant_id !== VOUCHERS.ICCA)
    },
    promoCertificationsOnCart() {
      const promoCertCodes = this.elegibleAvailableCertifications.map(
        promoCert => promoCert.merchant_id
      )
      const promoCertificationsOnCart = this.shoppingCart.filter(item =>
        promoCertCodes.includes(item.merchant_id)
      )
      return promoCertificationsOnCart.length > 0
    },
  },
  methods: {
    ...mapActions({
      setBundleProductError: 'shoppingCart/setBundleProductError',
    }),
    promoProductCheckItems() {
      if (this.promoBundlesOnCart) {
        const error = {}
        if (this.promoBundlesOnCart.slug === INE_BLACK_FRIDAY_BUNDLE_ONE) {
          if (!this.promoBundlesOnCart.bundle) {
            error.type = BF_ERRORS.BUNDLE_ERROR
            return error
          }
          if (this.promoBundlesOnCart.bundle && !this.promoBundlesOnCart.bundle.voucher) {
            error.type = BF_ERRORS.BUNDLE_ERROR_VOUCHER
            return error
          }
          if (this.promoBundlesOnCart.bundle && !this.promoBundlesOnCart.bundle.skill_dive_area) {
            error.type = BF_ERRORS.BUNDLE_ERROR_SD
            return error
          }
        }
        if (this.promoBundlesOnCart.slug === INE_BLACK_FRIDAY_BUNDLE_TWO) {
          if (!this.promoBundlesOnCart.bundle) {
            error.type = BF_ERRORS.BUNDLE_ERROR
            return error
          }
          if (this.promoBundlesOnCart.bundle && !this.promoBundlesOnCart.bundle.voucher) {
            error.type = BF_ERRORS.BUNDLE_ERROR_VOUCHER
            return error
          }
        }
        if ([INE_LEAP_YEAR_BUNDLE, INE_TCS_BUNDLE].includes(this.promoBundlesOnCart.slug)) {
          const errors = this.isTCSPromoEnabled ? TCS_ERRORS : LY_ERRORS
          if (!this.promoBundlesOnCart.bundle) {
            error.type = errors.BUNDLE_ERROR
            return error
          }
          if (!this.promoBundlesOnCart.bundle.voucher) {
            error.type = errors.BUNDLE_ERROR_VOUCHER
            return error
          }
        }
      }
    },
  },
}
